import { useEffect, useState } from "react";
import apiPaths from "../../api/paths";
import { apiRequest } from "../../api";
import { message } from "antd";
import ContactsModal from "./components/ContactsModal";
import WalletModal from "./components/WalletModal";
import SettingsModal from "./components/SettingsModal";

function Settings() {
  const [settings, setSettings] = useState({});

  const fetchSettings = async () => {
    const res = await apiRequest({
      path: apiPaths.siteSettings,
    });
    if (!res.error) {
      setSettings(res);
    } else {
      message.error(res.error_description);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <div style={{ height: "80vh" }}>
      <div style={{ display: "flex" }}>
        <ContactsModal contacts={settings.contacts} />
        <WalletModal walletSettings={settings.wallet_settings} />
        <SettingsModal settings={settings.settings} />
      </div>
    </div>
  );
}

export default Settings;
